import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#fff";
function BZE({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M10.464 18.346H6.198l.837-4.736 4.429-3.99H7.697l3.046-1.866h4.952L9.29 14.076l-.43 2.415s1.43.105 2.557 0c1.128-.116 2.395-.583 2.395-.583zm6.708-10.137l-1.907 1.867s1.605 1.784.128 4.234c-1.453 2.403-6.277 1.96-6.277 1.96l.372-2.111 6.788-6.627H10.65l.57-3.22H8.5l-.977 5.506h3.465l-4.116 3.71L6 18.522s3.29.093 6.08 0c2.802-.094 6.068-2.497 6.545-5.215.65-3.674-1.453-5.097-1.453-5.097" /><path  d="M10.09 18.908H5.822l.837-4.736 4.429-3.99H7.322l3.046-1.866h4.952l-6.405 6.323-.43 2.415s1.43.105 2.557 0c1.128-.117 2.395-.583 2.395-.583zm6.707-10.137l-1.906 1.867s1.604 1.785.127 4.235c-1.453 2.403-6.277 1.96-6.277 1.96l.372-2.112 6.789-6.626h-5.627l.57-3.22h-2.72l-.977 5.506h3.465l-4.116 3.71-.872 4.993s3.29.093 6.08 0c2.802-.094 6.068-2.497 6.545-5.215.65-3.675-1.453-5.098-1.453-5.098" /></Svg>;
}
BZE.DefaultColor = DefaultColor;
export default BZE;